import { FormScriptResponse } from "~/models/Commons ";
import { SIMPLDialog } from "../.././components/commons/dialog/SimplDialog";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { useTranslation } from "react-i18next";

interface DetailProps {
  item: FormScriptResponse;
  onClose: () => void;
}

const labelClass = "font-semibold max-w-[300px]";
 const DetailViewScript = ({ item, onClose }: DetailProps) => {
  const { t } = useTranslation();
  return (
    <SIMPLDialog onCloseModal={onClose} title={t("DetailView")}>
      <div className="w-auto p-2 pb-5 flex flex-col">
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("DeploymentScriptID")}</div>
            <div className="">{item.scriptIdentify.deploymentScriptId}</div>
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("DateAdded")}</div>
            <div className="">{item.creationDate}</div>
          </div>
          <div className="flex-1 ml-3">
            <div className={labelClass}>{t("Status")}</div>
            <div
              className={`inline-flex items-center justify-center min-h-[32px] min-w-[64px] rounded-full opacity-100 px-3 py-[var(--spacing-2xs)] gap-2 font-bold text-black ${
                item.active
                  ? "bg-[var(--color-primary-lightest,#F9E4F5)]"
                  : "bg-gray-200"
              }`}
            >
              <span className="flex items-center justify-center w-5 h-5 rounded-full -[var(--color-primary-lightest,#F9E4F5)]">
                <CheckCircleOutlineOutlinedIcon fontSize="small" />
              </span>
              {item.active ? t("Active") : t("Inactive")}
            </div>
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("CloudProvider")}</div>
            <div className="">
              {item.cloudEnvironment?.cloudProvider?.cloudProviderName}
            </div>
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("CloudEnvironment")}</div>
            <div className="">{item?.cloudEnvironment?.environmentName}</div>
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("Iac")}</div>
            <div className="">{item.cloudEnvironment?.iac}</div>
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("DataCenterName")}</div>
            <div className="">{item.cloudEnvironment?.datacenterName}</div>
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1">
            <div className={labelClass}>{t("Title")}</div>
            <div className="">{item.title}</div>
          </div>
        </div>

        <div className="flex flex-row mt-3">
          <div className="flex-1 truncate">
            <div className={labelClass}>{t("Description")}</div>
            <div className="">{item.description}</div>
          </div>
        </div>
      </div>
    </SIMPLDialog>
  );
};
export default DetailViewScript;